export const LANGUAGES = [
    { label: 'English', code: 'en' },
    { label: 'French', code: 'fr' },
]
